<template>
  <div class="container">
    <div class="logo">
      <img src="../../assets/logo-booksy.png">
    </div>
  </div>
</template>

<script>
import VueSimpleSVG from 'vue-simple-svg';
import Vue from 'vue';

Vue.use(VueSimpleSVG);

export default {
  name: 'Dashboard',
};
</script>

<style src="./Dashboard.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue